import React from 'react';

const SupplementsSection = () => {
  return (
    <section className="w-full bg-[#1a1a1a] text-white py-12 md:py-16">
      <div className="max-w-5xl mx-auto px-4">
        <div className="flex flex-col items-center">
          <video
            autoPlay
            muted
            loop
            playsInline
            controls
            className="w-full max-w-4xl h-auto rounded-lg shadow-2xl"
          >
            <source 
              src="https://customer-assets.emergentagent.com/job_prysm-replica/artifacts/7x084l25_Scanner%20in%20the%20news%20Highlights-852x480-avc1-mp4a.mp4" 
              type="video/mp4" 
            />
            Your browser does not support the video tag.
          </video>
          
          {/* Text below video */}
          <div className="mt-8 text-center">
            <h3 className="text-2xl md:text-3xl font-semibold text-white mb-2">
              See us in the news
            </h3>
            <p className="text-gray-400 text-lg">
              Featured on over 10 news programs
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupplementsSection;
